export default  {
  bindings: {
    page: '='
  },
  controller: 'pageContentGenericController',
  template: require('../views/pageContent.checkout.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/pageContent/components/pageContent.checkout.component.js